<!-- eslint-disable -->
<template lang="pug">
    .map-banner(
        :class=`[
            isAnimated && 'map-banner--animated',
        ]`,
        @mouseover="stopInterval",
        @mouseout="startInterval",
    )
        .map-banner__current-place
            .map-banner__image(:style="bannerStyle")
        .map-banner__info
            .map-banner__header
                | {{ $i18n.t('dashboard.dashboard_map_headerTitle') }}
            .map-banner__text
                template(v-if="isFirstTime")
                    | {{ $i18n.t('dashboard.dashboard_map_introduction') }}
                template(v-else-if="isInvitedToWatchFinal")
                    |  {{ $i18n.t('dashboard.dashboard_map_message') }}
                template(v-else)
                    | {{  $i18n.t('dashboard.dashboard_map_location') }}
                    | {{  $i18n.t('mapModal.cases.prepositional')[user.mapLocation.name] }}!
                    br
                    template(v-if="$lastMapAvailableLocation !== user.mapLocation.name")
                        template(v-if="isEnoughMiles")
                            | {{  $i18n.t('dashboard.dashboard_map_enoughMiles') }}
                            | {{  $i18n.t('mapModal.locationsWithPretext')[user.mapLocation.nextCity] }}!
                        template(v-else-if="user.mapLocation.nextCity")
                            span(v-html="$i18n.t('dashboard.dashboard_map_notEnoughMilesTakeMore', {'value': '<strong>' + (user.mapLocation.requiredMiles - user.miles) + '</strong>'})")
                            | &nbsp;
                            span {{ $i18n.t('mapModal.locationsWithPretext')[user.mapLocation.nextCity] }}!
            .map-banner__button
                cs-button(
                    v-if="isFirstTime"
                    color="blue"
                    @click="$router.push({name: 'map', params: { modal: true} })"
                )
                    | {{ $i18n.t('dashboard.dashboard_map_introductionStart') }}
                cs-button(
                    v-else-if="isInvitedToWatchFinal"
                    color="blue"
                    @click="$router.push({name: 'map', params: { video: true} })"
                )
                    | {{ $i18n.t('dashboard.dashboard_map_seeVideo') }}
                template(v-else)
                    cs-button(
                        v-if="$lastMapAvailableLocation !== user.mapLocation.name && isEnoughMiles"
                        color="blue"
                        @click="$router.push({name: 'map', params: { modal: true }})"
                    )
                        | {{ $i18n.t('dashboard.dashboard_map_goNext') }}
                    template(v-else)
                        progress.map-banner__progress(
                            v-if="$lastMapAvailableLocation !== user.mapLocation.name && user.mapLocation.nextCity"
                            :value="user.miles"
                            :max="user.mapLocation.requiredMiles"
                        )
                        cs-button(
                            color="blue"
                            @click="$router.push({name: 'map'})"
                        )
                            | {{ $i18n.t('dashboard.dashboard_map_goMap') }}
</template>

<script>
    /*eslint-disable*/
    import {mapState} from 'vuex'
    import SuccessTurtle from '../../../assets/images/SuccessTurtle.png';
    import CITIES from '../../../config/cities.json'

    export default {
        data () {
            return {
                isAnimated: false,
                animateInterval: null
            };
        },
        mounted () {
            this.isFirstTime && this.startInterval()
        },
        methods: {
            startInterval () {
                this.isFirstTime && (this.animateInterval = setInterval(() => {
                    this.isAnimated = !this.isAnimated
                }, 600))
            },
            stopInterval () {
                if (this.animateInterval) {
                    clearInterval(this.animateInterval)
                    this.isAnimated = false
                }
            }
        },
        computed: {
            ...mapState({
                user: state => state.auth.user,
            }),
            isEnoughMiles () {
                return this.user.miles >= this.user.mapLocation.requiredMiles;
            },
            isFirstTime () {
                return this.user.mapLocation.name === 'Introduction'
            },
            isInvitedToWatchFinal() {
                return this.user.mapLocation.name === CITIES[CITIES.length - 1];
            },
            bannerStyle () {
                let background = CITIES[CITIES.length - 1] !== this.user.mapLocation.name ?
                    `url(${this.user.mapLocation.image})` :
                    `url(${SuccessTurtle})`;

                let style = {
                    background: background,
                    'background-size': 'contain',
                    'background-position': 'center center',
                    'background-repeat': 'no-repeat',
                    height: '220px',
                }
                if (this.user.mapLocation.name !== 'Introduction') {
                    style['border-radius'] = '50%';
                }
                return style;
            },
        },
    }
</script>

<style lang="scss" scoped>
		.map-banner {
				box-sizing: border-box;
				background-color: $hsl-color-gray-98;
				border-radius: $border-radius-20;

				display: flex;
				flex-direction: column;
				justify-content: space-between;

				transition: transform 0.5s cubic-bezier(0.68, -0.55, 0.265, 1.55);

				&:not(:last-child) {
            margin-bottom: 30px;
        }
    }

    .map-banner--animated {
        transform: scale(1.05, 1.05);
    }

    .map-banner__header {
        font-weight: 500;
        font-size: 22px;
        line-height: 26px;
    }

    .map-banner__text {
        margin-top: 10px;
        font-size: 16px;
        line-height: 24px;
    }

    .map-banner__button {
        margin-top: 13px;
    }

    .map-banner__current-place {
        margin: 30px auto;
        width: 220px;
        height: 220px;
        background-color: $x-color-white;
        border-radius: $border-radius-circle;
    }

    .map-banner__info {
        margin: 0 30px 30px;
    }

    .map-banner__progress {
        margin-bottom: 20px;

        appearance: none;
        border: none;

        width: 100%;

        color: $hsl-color-green-58;
        background-color: $hsl-color-gray-92;
        border-radius: $border-radius-20;

        &::-webkit-progress-bar {
            background-color: $hsl-color-gray-92;
            border-radius: $border-radius-20;
        }

        &::-webkit-progress-value {
            background-color: $hsl-color-green-58;
            border-radius: $border-radius-20;
        }

        &::-moz-progress-bar {
            background-color: $hsl-color-green-58;
            border-radius: $border-radius-20;
        }
    }
</style>
